var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black_8_",
    transform: "translate(-300.000000, -405.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line-3_1_",
    transform: "translate(200.000000, 400.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vimeo_1_",
    className: "st0",
    d: "M380.1,95.2c-1.1,25.1-18.9,59.3-53.1,102.8 c-35.4,45.5-65.4,68.2-89.9,68.2c-15.2,0-28-13.8-38.5-41.6c-7-25.4-14-50.9-21-76.3c-7.8-27.7-16.2-41.6-25.1-41.6 c-1.9,0-8.7,4-20.4,12.2l-12.2-15.6c12.8-11.1,25.5-22.3,38-33.5c17.1-14.6,29.9-22.3,38.5-23.1c20.2-1.9,32.7,11.7,37.4,41 c5,31.6,8.5,51.2,10.5,58.9c5.8,26.2,12.2,39.2,19.3,39.2c5.4,0,13.6-8.5,24.5-25.4c10.9-17,16.7-29.8,17.5-38.7 c1.6-14.6-4.3-21.9-17.5-21.9c-6.2,0-12.7,1.3-19.3,4c12.9-41.2,37.4-61.2,73.5-60.1C369,44.6,381.6,61.7,380.1,95.2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.7099ea5c6eb7e10264dadf254f807557.svg";
export { ForwardRef as ReactComponent };